import qs from 'qs';
import { useContext } from 'react';
import type { VoidFunctionComponent } from 'react';

import { RouterContext } from '../../../../contexts/RouterContext';
import { LONG_DATE_FORMAT } from '../../../../helpers/date';
import CardBanner, { CardBannerVariant } from '../../../generic/CardBanner';
import icons from '../../../generic/Icon/icons';

type SubscriptionBannerPendingProps = {
  planName: string;
  startDate: number,
};
const SubscriptionBannerPending: VoidFunctionComponent<SubscriptionBannerPendingProps> = ({
  planName,
  startDate,
}) => {
  const {
    getRouter,
    getLocation,
  } = useContext(RouterContext);
  const { pathname } = getLocation();
  const isBillingPage = pathname.startsWith('/account/settings/billing');

  return (
    <CardBanner
      title="You downgraded your plan"
      description={
        <>
          <b>You recently downgraded to {planName}.</b>
          &nbsp;Your new subscription starts on {LONG_DATE_FORMAT.format(new Date(startDate * 1000))}.
        </>
      }
      icon={icons.arrowDown}
      variant={CardBannerVariant.INFO}
      cta={!isBillingPage ?
          {
            text: 'View more details',
            onClick: () => {
              getRouter().push(`/account/settings/billing?${qs.stringify({ tab: 'Plans' })}`);
            },
            isFullWidth: true,
          }
        : undefined}
    />);
};

export default SubscriptionBannerPending;
